import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { CATEGORIES_ADDITIONAL_CLASS, CATEGORIES_WITH_NEW_LANDING } from 'CONFIG';
import classNames from 'classnames';
import { Col } from 'reactstrap';
import { CATEGORY_STATUS } from 'MODULES/const';
import { useSelector } from 'react-redux';
import { getSelectedLanguage } from 'MODULES/reselect/selectors/general';
import size from 'lodash/size';
import map from 'lodash/map';
import { hideContentFromUserAgent } from 'MODULES/hideContentFromUserAgent';
import { PP_URLS } from 'CONFIG/PP_URLS';
import { CATEGORIES } from 'MODULES/CATEGORIES';
import { catColor } from 'MODULES/catColor';

const mapIcon = cat => ({
    'pp-zcat_transport':  cat.id === CATEGORIES.transport,
    'pp-zcat_food': cat.id === CATEGORIES.food,
    'pp-zcat_services': cat.id === CATEGORIES.services,
    'pp-zcat_pets': cat.id === CATEGORIES.animals,
    'pp-globe': cat.id === CATEGORIES.whereToBuy,
    'pp-zcat_electronics': cat.id === CATEGORIES.electronic,
    'pp-zcat_gardening': cat.id === CATEGORIES.gardenForestMachinery,
    'pp-zcat_real_estate': cat.id === CATEGORIES.realEstate,
    'pp-zcat_construction': cat.id === CATEGORIES.construction,
    'pp-zcat_home_stuff': cat.id === CATEGORIES.homeStuff,
    'pp-zcat_clothes': cat.id === CATEGORIES.clothes,
    'pp-zcat_production': cat.id === CATEGORIES.production,
    'pp-zcat_agriculture': cat.id === CATEGORIES.agriculture,
    'pp-zcat_hobby': cat.id === CATEGORIES.hobby,
    'pp-zcat_kids': cat.id === CATEGORIES.kids,
    'pp-zcat_charity': cat.id === CATEGORIES.charity,
    'pp-zcat_health': cat.id === CATEGORIES.health,
    'pp-zcat_adult': cat.id === CATEGORIES.adultContent,
    'pp-zcat_christmas': cat.id === CATEGORIES.christmas,
    'pp-zcat_christmas_offers': cat.id === CATEGORIES.christmasOffers
});

const DefaultParentItem = ({ cat, i18n }) => {
    const lang = useSelector(getSelectedLanguage);
    const crawler = hideContentFromUserAgent();
    if (cat.id === CATEGORIES.adultContent && crawler) {
        return null;
    } return (
        <Col sm={12} md={6} lg={3}>
            {cat.status === CATEGORY_STATUS.comingSoon
                ? (
                    <div className="category-level-0 coming-soon">
                        <i
                            className={
                                classNames(
                                    'pp-landing',
                                    mapIcon(cat)
                                )
                            }
                        />
                        <div>
                            <h1>{cat.name[lang]}</h1>
                        </div>
                        <h2>{i18n.__('Soon!')}</h2>
                    </div>
                )
                : (
                    <>
                        <Link
                            to={{
                                pathname:      size(cat.children) > 0 && CATEGORIES_WITH_NEW_LANDING.indexOf(cat.id) === -1
                                    ? PP_URLS.LANDING(lang, cat.slug[lang])
                                    : PP_URLS.CATEGORY(cat.slug[lang], lang)

                            }}
                            className={classNames('cat-list', {
                                [CATEGORIES_ADDITIONAL_CLASS[cat.id]]: CATEGORIES_ADDITIONAL_CLASS[cat.id],
                                [catColor[cat.id]]: true
                            })}
                        >
                            <div className="category-level-0">
                                <i
                                    className={
                                        classNames(
                                            'pp-landing',
                                            mapIcon(cat)
                                        )
                                    }
                                />
                                {cat.id === CATEGORIES.christmasOffers
                                    && (
                                        <div className="decor__position d-md-none">
                                            <i className="decor__1" />
                                            <i className="decor__2" />
                                        </div>
                                    )}
                                <div>
                                    <h2>{cat.name[lang]}</h2>
                                    {cat.id !== CATEGORIES.adultContent && size(cat.children) > 0 && (
                                        <div className="subcat">
                                            {map(cat.children, (subcat, index) => index < 6 && [
                                                <h3 key={subcat}>
                                                    {subcat.name[lang]}
                                                    {index !== cat.children.length - 1 && ','}
                                                </h3>
                                            ])}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Link>
                        <div className="h025rem" />
                    </>
                )}
        </Col>
    );
};

export default memo(DefaultParentItem);
